@if (visible) {
  <div class="image-quality-rating" [class]="imageQualityRating">
    <div class="image-quality-rating-info">
      <mat-icon [svgIcon]="imageQualityRating"></mat-icon>
      <div class="image-quality-rating-message">
        <span class="image-quality-rating-title">
          {{ messageTitle }}
          @if (totalImageCount > 1 && badImagesCount > 0) {
            ({{ badImagesCounterLabel }})
          }
        </span>
        <span class="image-quality-rating-content"
            [class.toggle-indicators]="totalImageCount > 1">
          @if (totalImageCount > 1) {
            <span (click)="toggleQualityIndicators()">
              @if (!qualityIndicatorsVisible) {
                {{ 'i18n.control.imageQuality.showIndicators' | translate }}
              }
              @else {
                {{ 'i18n.control.imageQuality.hideIndicators' | translate }}
              }
            </span>
          }
          @else
          {
            {{ messageContent }}
          }
        </span>
      </div>
    </div>
    @if (totalImageCount < 2) {
      <button mat-icon-button (click)="openImageQualityInfoOverlay()">
        <mat-icon svgIcon="info"></mat-icon>
      </button>
    }
  </div>
}
